export const DAY_IN_SECONDS = 86400;
export const YEAR_IN_SECONDS = 31536000;
export const SITE_BASE =
  process.env.NEXT_PUBLIC_ORIGIN || "https://www.solarwinds.com";

export const LOCALE_PREFERENCE_COOKIE_NAME = "swiIsoLocalePreference";
